import React, { useMemo } from 'react'
import { SubwebsCardList } from 'components/organisms'
import { useUserContext } from 'context/UserContext';
import { generateSubwebsWithFavoritesFirst } from 'services/generators'
import PropTypes from 'prop-types'

const SubwebsUserList = ({ max }) => {
  const [{
    user, subwebsFavorites,
  }] = useUserContext();

  const subwebs = useMemo(() => {
    let computed = []
    if (!user || !user.subwebs) return computed
    computed = generateSubwebsWithFavoritesFirst(user.subwebs, subwebsFavorites)
    return computed.slice(0, max)
  }, [user, max, subwebsFavorites])

  return (
    <SubwebsCardList data={subwebs} />
  )
}

SubwebsUserList.propTypes = {
  max: PropTypes.number,
}

SubwebsUserList.defaultProps = {
  max: 8,
}

export default SubwebsUserList
